module.exports = __webpack_public_path__ + "static/media/chef-hat.63da14a8.svg";